module.exports = __webpack_public_path__ + "img/payment-journal.202c2772.svg";